import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class TitleGeneratorCommand extends RequestData<string | undefined> {
  constructor(public readonly abstract: string) {
    super()
  }
}

export const generateTitle = (abstract: string) =>
  mediator.send<string | undefined>(new TitleGeneratorCommand(abstract))
